import { jsx as x } from "react/jsx-runtime";
import { useIsLoggedIn as C } from "../hooks/useIsLoggedIn.js";
import { UnitHooks as T, SystemHooks as b, logout as y, AccountService as E, handleError as P } from "@propify-tenant-client/services";
import l from "lodash/noop";
import { createContext as U, useState as c, useCallback as f, useEffect as k } from "react";
import { useNavigate as B } from "react-router";
const d = {
  environment: "",
  personaTemplateId: "",
  googlePayMerchantId: "BCR2DN6TWPSO3VZC",
  paymentCycleDays: 60,
  showingsPerPaymentCycle: 15,
  dropboxSignConfiguration: {
    testMode: !1,
    skipDomainVerification: !1,
    locale: void 0,
    clientId: ""
  }
}, F = U({
  updateLogin: l,
  login: void 0,
  loadingLogin: !1,
  loadingRentedUnit: !1,
  rentedUnit: void 0,
  system: void 0,
  loadingSystemConfig: !1,
  accountBanned: !1,
  setAccountBanned: l,
  logout: l
}), H = ({ children: v }) => {
  const [t, a] = c(), [i, g] = c(!1), [S, u] = c(!1), m = B(), { isLoggedIn: n } = C(), { data: r, isFetching: I } = T.useRentedUnit({
    disabled: !n
  }), { data: o, isFetching: h } = b.useConfig({
    disabled: !n
  }), L = f(
    (e = "/user/login") => {
      y(), a(void 0), u(!1), m(e);
    },
    [m]
  ), p = f(async (e) => {
    if (e) {
      a(e);
      return;
    }
    try {
      g(!0);
      const s = await E.me();
      a(s);
    } catch (s) {
      P(s, {
        toastFallbackMessage: "There was an error fetching the account information"
      });
    } finally {
      g(!1);
    }
  }, []);
  return k(() => {
    n && !t && !i && p();
  }, [n, t, i]), /* @__PURE__ */ x(
    F.Provider,
    {
      value: {
        updateLogin: p,
        login: t,
        loadingLogin: i,
        rentedUnit: r == null ? void 0 : r[0],
        loadingRentedUnit: I,
        system: {
          ...d,
          environment: (o == null ? void 0 : o.environment) ?? d.environment,
          personaTemplateId: (o == null ? void 0 : o.personaTemplateId) ?? d.personaTemplateId,
          personaEnvironment: o == null ? void 0 : o.personaEnvironment,
          dropboxSignConfiguration: o == null ? void 0 : o.dropboxSignConfiguration
        },
        loadingSystemConfig: h,
        accountBanned: S,
        setAccountBanned: u,
        logout: L
      },
      children: v
    }
  );
};
export {
  F as SessionContext,
  H as SessionContextProvider
};
//# sourceMappingURL=SessionContext.js.map
